declare var google;
export class MapPosition {
  public latitude = null;
  public longitude = null;
  public height = null;

  get lat() { return this.latitude; }
  get lng() { return this.longitude; }

  constructor(position) {
    if (position.hasOwnProperty('lat')) {
      this.latitude = parseFloat(position.lat);
    }
    if (position.hasOwnProperty('lng')) {
      this.longitude = parseFloat(position.lng);
    }

    if (position.hasOwnProperty('latitude')){
      this.latitude = parseFloat(position.latitude);
    }

    if (position.hasOwnProperty('longitude')){
      this.longitude = parseFloat(position.longitude);
    }

    if (position.hasOwnProperty('height')) {
      this.height = position.height;
    } else if (position.hasOwnProperty('z')) {
      this.height = position.z;
    }
  }

  public asArray() {
    if (this.height === null) {
      return [this.latitude, this.longitude];
    } else {
      return [this.latitude, this.longitude, this.height];
    }
  }

  public asSimpleArray(){
    return [this.longitude, this.latitude];
  }

  public  asSimpleObject() : Object {
    return {
      lat: this.lat,
      lng: this.lng,
      height: this.height
    };
  }

  public asGoogleMapsLatLng() {
    return new google.maps.LatLng(parseFloat(this.lat), parseFloat(this.lng));
    // return {
    //   lat: () => parseFloat(this.lat),
    //   lng: () => parseFloat(this.lng),
    //   _lat: this.lat,
    //   _lng: this.lng
    // };
  }

  public equals(m:MapPosition) {
    return (
      MapPosition.coordinateEqual(this.lat, m.lat)
      && MapPosition.coordinateEqual(this.lng, m.lng)
      && MapPosition.coordinateEqual(this.height, m.height)
    );
  }

  public clone() :MapPosition {
    return MapPosition.fromArray(this.asArray());
  }

  public static coordinateEqual(n1, n2) {
    if (n1 === null && n2 === null) { return true; }
    if (n1 === null || n2 === null) { return false; }
    n1 = parseFloat(n1);
    n2 = parseFloat(n2);
    if (isNaN(n1) || isNaN(n2)) { return false; }
    return n1.toFixed(7) === n2.toFixed(7);
  }

  public static fromArray(position : number[]) : MapPosition {
    return new MapPosition({
      lat: position[0],
      lng: position[1],
      height: position.length > 2 ? position[2] : null
    });
  }

  public static fromLatLng(position: Object[]): MapPosition {
    return new MapPosition({
      lat: position['lat'],
      lng: position['lng'],
      height: position.hasOwnProperty('z') ? position['z'] : null
    });
  }
}


